import { render, staticRenderFns } from "./DoubleButtons.vue?vue&type=template&id=7562f70a&"
import script from "./DoubleButtons.vue?vue&type=script&lang=js&"
export * from "./DoubleButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports